import PropTypes from 'prop-types';

// Material-UI
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

// Hooks
import useResponsive from 'hooks/useResponsive';

// Components
import ProductCardGlideCarousel from 'components/Carousels/core/ProductCardGlideCarousel';

const MoreProductsFromThisBrand = ({ products = [], isLoading = true, carouselSettings = {} }) => {
  const isMobile = useResponsive('down', 'sm');

  if (!products || !products?.length) return null;

  return (
    <Container maxWidth="xl" disableGutters={isMobile} sx={{ mb: 3 }}>
      <ProductCardGlideCarousel
        sx={{ mt: isMobile ? 1 : 3 }}
        products={products}
        isLoading={isLoading}
        title={
          <Typography component="h2" variant="h6" fontWeight="fontWeightMedium">
            More products from this brand
          </Typography>
        }
        carouselSettings={carouselSettings}
      />
    </Container>
  );
};

export default MoreProductsFromThisBrand;

MoreProductsFromThisBrand.propTypes = {
  sx: PropTypes.shape({}),
  carouselSettings: PropTypes.shape({}),
};
